<mat-spinner [diameter]="86" *ngIf="loading"></mat-spinner>
<ng-container *ngIf="!loading">
  <div class="context">
    <div class="ctx-left">
      <div class="ctx-logo">
        <app-image
          *ngIf="platformInfo.product_icon"
          [fileid]="platformInfo.product_icon"
          [radius]="8"
        ></app-image>
        <!-- 演示数据没有真实产品图时，用首字母图标兜底 -->
        <span class="demo-logo" *ngIf="!platformInfo.product_icon">{{
          (platformInfo.order?.platform_name || "?").charAt(0)
        }}</span>
      </div>
      <div class="ctx-copy">
        <strong>{{ platformInfo.order.platform_name }}</strong>
        <span>{{ platformInfo.account }}</span>
        <div class="path">
          <i class="chip">当前账号</i><b class="arrow">›</b>
          <i class="chip">{{ problemInfo.name }}</i>
        </div>
      </div>
    </div>
  </div>
  <h2 class="title" id="actionTitle">选择处理方式</h2>
  <div class="route-panel">
    <div class="route-grid">
      <ng-container *ngFor="let item of data; let i = index">
        <button
          *ngIf="isVisible(item.key)"
          type="button"
          class="route-card"
          (click)="selectTab(item)"
          [ngClass]="{ active: index === i }"
        >
          <div class="route-card-top">
            <div>
              <h3>{{ item.txt1 }}</h3>
              <p>{{ item.txt2 }}</p>
            </div>
            <div class="route-icon">{{ item.txt3 }}</div>
          </div>
        </button>
      </ng-container>
    </div>
  </div>
  <div class="eta-card" [ngClass]="{ active: index === 0 }">
    <div class="eta-icon">↻</div>
    <div class="eta-copy">
      <span>预计处理时间</span
      ><strong>{{ getTime(problemInfo.help_estimated_minutes) }}</strong>
      <p>打开后即可按步骤处理</p>
    </div>
  </div>
  <div class="eta-card" [ngClass]="{ active: index === 1 }">
    <div class="eta-icon">↻</div>
    <div class="eta-copy">
      <span>预计处理时间</span>
      <strong> {{ getTime(problemInfo.ai_estimated_minutes) }}</strong>
      <p>AI 客服全天可用</p>
    </div>
  </div>
  <div class="eta-card" [ngClass]="{ active: index === 2 }">
    <div class="eta-icon">↻</div>
    <div class="eta-copy">
      <span>预计处理时间</span
      ><strong>{{ getTime(problemInfo.ticket_estimated_minutes) }}</strong>
      <p>预计开始核验或完成处理</p>
    </div>
  </div>
  <div class="action-grid" [ngClass]="{ active: index === 2 }">
    <div>
      <div class="form" id="form">
        <div class="form-title">
          问题说明 <span class="required">必填</span>
        </div>
        <div class="hint" id="hint">
          请写明出现问题的设备、页面提示和已尝试的操作。
        </div>
        <div
          style="
            margin: 12px 0 8px;
            padding: 12px 14px;
            background: #fffbeb;
            border: 1px solid #fde68a;
            border-left: 4px solid #f59e0b;
            border-radius: 8px;
            font-size: 12px;
            color: #92400e;
            line-height: 1.5;
          "
        >
          <b style="display: block; margin-bottom: 4px; color: #b45309"
            >⚠️ 强烈建议：</b
          >
          请准确描述问题，以免因信息不清导致处理延误或无法解决。
        </div>
        <textarea
          class="text"
          maxlength="500"
          placeholder="例如：电视提示密码错误，已重试两次。"
          [(ngModel)]="input"
          [ngClass]="{ error: errorInput }"
        ></textarea>
        <div class="quick">
          <button
            type="button"
            class="qw"
            *ngFor="let item of list1"
            (click)="addWord(item.txt)"
          >
            {{ item.txt }}
          </button>
        </div>
        <div class="upload" id="uploadBox" [ngClass]="{ error: errorImage }">
          <label for="file">＋ 添加问题截图 <b>必填</b></label>
          <input
            id="file"
            class="hidden"
            type="file"
            accept="image/*"
            (change)="onFileChange($event)"
          />
          <span class="filename" id="filename">
            <ng-container *ngIf="!image; else hasImage">
              尚未选择截图
            </ng-container>
            <ng-template #hasImage>{{ image?.name }}</ng-template>
          </span>
        </div>
        <div
          class="form-error"
          id="formError"
          [ngClass]="{ active: errorImage || errorInput }"
        >
          请填写完整
        </div>
        <div class="preview" id="preview">
          <strong>提交前确认</strong>
          <div>
            <b>{{ platformInfo.order.platform_name }}</b> ·
            {{ platformInfo.account }}
          </div>
        </div>
        <div class="actions">
          <button class="link" (click)="backStep()">‹ 返回处理方式</button>
          <button class="primary-btn" id="submit" (click)="submit()">
            提交工单
          </button>
        </div>
      </div>
    </div>
    <aside class="side" id="side">
      <h3>本次支持概览</h3>
      <div class="row">
        <span>产品</span><span>{{ platformInfo.order.platform_name }}</span>
      </div>
      <div class="row">
        <span>账号</span>
        <span>{{ platformInfo.account }}</span>
      </div>
      <div class="row">
        <span>问题</span><span>{{ problemInfo.name }}</span>
      </div>
      <div class="row"><span>处理标记</span><span>可能需人工</span></div>
      <div class="row"><span>处理路径</span><span>售后工单</span></div>
    </aside>
  </div>
</ng-container>
